// Because of the inconsistant between backend enum key and value
// Backend returned data is enum key
// Backend required filter data is enum value
export enum PROGRAMME_NAME_FILTER {
  MASTER_OF_PHILOSOPHY = 'M',
  DOCTOR_OF_PHILOSOPHY = 'D',
}

export enum PROGRAMME_TYPE_FILTER {
  GENERAL_PROGRAMME = 'GENERAL',
  DUAL_PHD_DEGREE_PROGRAMME = 'DUAL',
  COLLABORATIVE_PHD_DEGREE_PROGRAMME = 'COLLABORATIVE',
}

// for action column
export enum COMMON_ACTION {
  MONITOR = 1,
  VIEW_AS,
  ONE_OFF,
}
